import { Box, DashboardModule, Link } from '@domain-group/suit-theme'

import combineAgentsAndTeamMembers from '@functions/campaign'

import useSelector from '@hooks/useSelector'
import useTeamMembers from '@hooks/useTeamMembers'

import type { CampaignModel } from '@models/types'

import TeamMember from './TeamMember'

interface TeamProps {
  callbacks?: {
    manageTeam: () => void,
  },
  campaign: CampaignModel,
}

const CampaignTeam = (props: TeamProps) => {
  const { callbacks, campaign } = props
  const { manageTeam } = callbacks || {}

  const { team_id, agents: agentIds = [] } = campaign

  const agents = useSelector(reduxState => reduxState.entities.agents)

  const { filteredTeamMembers } = useTeamMembers({ filters: { team_id } })
  const teamMembers = team_id ? filteredTeamMembers : []

  const filteredMembersAndAgents = combineAgentsAndTeamMembers(teamMembers, agentIds, agents)
  const hasFilteredMembersAndAgents = !!filteredMembersAndAgents.length

  return (
    <DashboardModule
      headerRight={manageTeam ? (
        <Link
          onClick={() => manageTeam()}
          textProps={{ fontSize: 'small' }}
        >
          Manage
        </Link>
      ) : null}
      title="Agents"
    >
      {hasFilteredMembersAndAgents && (
        <Box paddingX="large" flexDirection="column">
          {filteredMembersAndAgents.map(member => (
            <TeamMember key={member.user_id} member={member} />
          ))}
        </Box>
      )}
    </DashboardModule>
  )
}

export default CampaignTeam
